import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-10 bg-background-50 border-b border-background-200/60">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
          {categoryList.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 hover:bg-primary-50 text-sm text-foreground-700 hover:text-primary-500 transition-all whitespace-nowrap flex-shrink-0 cursor-pointer border border-background-200/60 hover:border-primary-200"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}